export default __webpack_public_path__ + "static/media/art-slt-4.64c1c2f7.png";